import { render } from "./IniFileGSensorSetting.vue?vue&type=template&id=17b23a47&scoped=true"
import script from "./IniFileGSensorSetting.vue?vue&type=script&lang=js"
export * from "./IniFileGSensorSetting.vue?vue&type=script&lang=js"

import "./IniFileGSensorSetting.vue?vue&type=style&index=0&id=17b23a47&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17b23a47"]])

export default __exports__